import { render, staticRenderFns } from "./lazy-table.vue?vue&type=template&id=8428641c&scoped=true"
import script from "./lazy-table.vue?vue&type=script&lang=js"
export * from "./lazy-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8428641c",
  null
  
)

export default component.exports